module.exports = __webpack_public_path__ + "static/media/logo.fa9a6da2.jpg";